import { ChatsCircle, FilmSlate } from '@phosphor-icons/react';
import { matchUploadLine } from './liveLessonText';

/**
 * The two ways to use a Live Video Lesson (redesign spec, batch 1), worded
 * once for the coach profile's card and the mode step.
 */
export type LiveLessonMode = 'match_review' | 'guidance_call';

export function liveModeLines(first: string) {
  return [
    { key: 'match_review' as LiveLessonMode, label: 'Match Review', Icon: FilmSlate,
      text: `Upload your match or practice. By the time you join, ${first} has already watched and analyzed every point and knows exactly what to go over.` },
    { key: 'guidance_call' as LiveLessonMode, label: 'Guidance Call', Icon: ChatsCircle,
      text: 'No video needed. College recruiting, tournament planning, the mental game, or what to work on next.' },
  ];
}

/**
 * One line each, under the pay page's "What's this lesson for?" control:
 * what the player brings, said as the profile card says it.
 */
export function modeOneLine(mode: LiveLessonMode, first: string): string {
  return mode === 'match_review'
    // The one upload line (decisions 70 and 109), from its one source, so the two never differ again.
    ? matchUploadLine({ for: 'sheet', coachFirst: first })
    : 'No video needed: recruiting, tournaments, the mental game, what to work on next.';
}

/**
 * One line each in the lesson page's Lesson Type sheet, once it is booked:
 * a Match Review's is its upload line (matchUploadLine, 'sheet').
 */
export function modeChangeLine(mode: LiveLessonMode, uploadLine: string): string {
  return mode === 'match_review'
    ? uploadLine
    : 'No video needed: recruiting, tournaments, the mental game, what to work on next.';
}

export const MODE_LABEL: Record<LiveLessonMode, string> = {
  match_review: 'Match Review',
  guidance_call: 'Guidance Call',
};

/** Guidance Call topics, stored on the booking as guidanceTopics. */
export const GUIDANCE_TOPICS = ['College recruiting', 'Tournament planning', 'The mental game', 'What to work on next'];
